import _get from "lodash/get";
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { baseTheme } from '~base-theme';
import { GaIcon } from '~icon';
import ScrollButton from './ScrollButton';
import horizontalScrollTheme from '../styles/horizontalScrollTheme';

var ScrollAction = function ScrollAction(_ref) {
  var showStart = _ref.showStart,
      showEnd = _ref.showEnd,
      btnWidth = _ref.btnWidth,
      handleClick = _ref.handleClick,
      btnColor = _ref.btnColor,
      iconColor = _ref.iconColor,
      iconSize = _ref.iconSize;
  var theme = useContext(ThemeContext);

  var renderIconSize = iconSize || _get(theme, 'horizontalScroll.scrollbar.icon.size', horizontalScrollTheme.horizontalScroll.scrollbar.icon.size);

  var renderIconColor = iconColor || _get(theme, 'base.grays.gray', baseTheme.base.grays.gray);

  var renderButtonWidth = btnWidth || _get(theme, 'horizontalScroll.scrollbar.button.width', horizontalScrollTheme.horizontalScroll.scrollbar.button.width);

  return /*#__PURE__*/React.createElement(ScrollButton, {
    showStart: showStart,
    showEnd: showEnd,
    btnWidth: renderButtonWidth,
    onClick: handleClick,
    btnColor: btnColor,
    type: "button"
  }, showStart && /*#__PURE__*/React.createElement(GaIcon, {
    icon: "chevron-left",
    size: renderIconSize,
    color: renderIconColor
  }), showEnd && /*#__PURE__*/React.createElement(GaIcon, {
    icon: "chevron-right",
    size: renderIconSize,
    color: renderIconColor
  }));
};

ScrollAction.defaultProps = {
  showStart: false,
  showEnd: false,
  btnWidth: undefined,
  btnColor: undefined,
  iconColor: undefined,
  iconSize: undefined
};
export default ScrollAction;